import { Listing, Pet, PetAge } from 'shared/@types';
import { getPedigreeRegistryLink } from 'shared/library/pedigree';
import { getForSalePets, getParentPets } from 'shared/library/pet-roles';

type PetWithPedigreeLink = Pet & {
  pedigree_link?: string | null;
};

export function getListingPetPedigreeRegistryLink(listing: Listing, pet?: Pet | null) {
  return getPedigreeRegistryLink(listing, pet?.registration_id, {
    directHref: (pet as PetWithPedigreeLink | null | undefined)?.pedigree_link,
  });
}

export function hasListingVerifiedPedigree(listing: Listing) {
  const pets = listing.pets ?? [];
  const forSalePets = getForSalePets(pets);
  const pedigreePets =
    listing.pet_age === PetAge.Adult ? forSalePets : [...forSalePets, ...getParentPets(pets)];

  return pedigreePets.some((pet) => getListingPetPedigreeRegistryLink(listing, pet) !== null);
}
